type CustomerSearch = (
  field: 'externalTMSID' | 'name',
  value: string
) => Promise<unknown[]>;

export const fetchSuggestedCustomer = async (
  customerSearch: CustomerSearch,
  suggestedCustomerId: string
) => {
  const exactMatches = await customerSearch(
    'externalTMSID',
    suggestedCustomerId
  );

  if (exactMatches.length > 0) {
    return exactMatches;
  }

  return customerSearch('name', suggestedCustomerId);
};
